import LandscapeIcon from "@mui/icons-material/Landscape";
import ChildCareIcon from "@mui/icons-material/ChildCare";
import ApartmentIcon from "@mui/icons-material/Apartment";
import ScienceIcon from "@mui/icons-material/Science";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import SelfImprovementIcon from "@mui/icons-material/SelfImprovement";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import { useSelector, useDispatch } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import { Grid } from "@mui/material";

export default function Explore() {
  const state = useSelector((state) => state);

  return (
    <div
      className="news"
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        paddingBottom: "100px",
      }}
    >
      <div
        style={{
          textAlign: "left",
          marginBottom: "50px",
          marginTop: "-100px",
          fontSize: state.auth.isMobile ? "30px" : "40px",
          fontWeight: "bold",
          fontFamily: "Montserrat",
          color:
            state.auth.theme == "dark"
              ? themeStyleDark.primaryColor
              : themeStyle.primaryColor,
        }}
      >
        Explore BGS WORLD SCHOOL{" "}
      </div>
      <Grid
        container
        spacing={10}
        style={{
          width: "100%",
          justifyContent: "center",
          marginBottom: "25px",
        }}
      >
        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <LandscapeIcon
              className="nav-icon"
              style={{
                fontSize: 40,
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
              }}
            />
            <div
              style={{
                fontSize: state.auth.isMobile ? "16px" : "20px",
                marginLeft: "20px",
                marginTop: "5px",
                fontFamily: "Montserrat",
                textAlign: "left",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
              }}
            >
              Lush Green Campus
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <ChildCareIcon
              className="nav-icon"
              style={{
                fontSize: 40,
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
              }}
            />
            <div
              style={{
                fontSize: state.auth.isMobile ? "16px" : "20px",
                marginLeft: "20px",
                marginTop: "5px",
                fontFamily: "Montserrat",
                textAlign: "left",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
              }}
            >
              Kids Play Area
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <ApartmentIcon
              className="nav-icon"
              style={{
                fontSize: 40,
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
              }}
            />
            <div
              style={{
                fontSize: state.auth.isMobile ? "16px" : "20px",
                marginLeft: "20px",
                marginTop: "5px",
                fontFamily: "Montserrat",
                textAlign: "left",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
              }}
            >
              State-of-the-Art Infrastructure
            </div>
          </div>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={10}
        style={{
          width: "100%",
          justifyContent: "center",
          marginBottom: "25px",
        }}
      >
        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <ScienceIcon
              className="nav-icon"
              style={{
                fontSize: 40,
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
              }}
            />
            <div
              style={{
                fontSize: state.auth.isMobile ? "16px" : "20px",
                marginLeft: "20px",
                marginTop: "5px",
                fontFamily: "Montserrat",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                textAlign: "left",
              }}
            >
              Well-equipped Laboratories
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <SportsSoccerIcon
              className="nav-icon"
              style={{
                fontSize: 40,
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
              }}
            />
            <div
              style={{
                fontSize: state.auth.isMobile ? "16px" : "20px",
                marginLeft: "20px",
                marginTop: "5px",
                fontFamily: "Montserrat",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                textAlign: "left",
              }}
            >
              World Class Sports Facilities
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <SelfImprovementIcon
              className="nav-icon"
              style={{
                fontSize: 40,
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
              }}
            />
            <div
              style={{
                fontSize: state.auth.isMobile ? "16px" : "20px",
                marginLeft: "20px",
                marginTop: "5px",
                fontFamily: "Montserrat",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                textAlign: "left",
              }}
            >
              Yoga and 'Dhyana'
            </div>
          </div>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={10}
        style={{
          width: "100%",
          justifyContent: "center",
          marginBottom: "25px",
        }}
      >
        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <MusicNoteIcon
              className="nav-icon"
              style={{
                fontSize: 40,
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
              }}
            />
            <div
              style={{
                fontSize: state.auth.isMobile ? "16px" : "20px",
                marginLeft: "20px",
                marginTop: "5px",
                fontFamily: "Montserrat",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                textAlign: "left",
              }}
            >
              Performing Arts
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <LocalLibraryIcon
              className="nav-icon"
              style={{
                fontSize: 40,
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
              }}
            />
            <div
              style={{
                fontSize: state.auth.isMobile ? "16px" : "20px",
                marginLeft: "20px",
                marginTop: "5px",
                fontFamily: "Montserrat",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                textAlign: "left",
              }}
            >
              Well-architected Library
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <DirectionsBusIcon
              className="nav-icon"
              style={{
                fontSize: 40,
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
              }}
            />
            <div
              style={{
                fontSize: state.auth.isMobile ? "16px" : "20px",
                marginLeft: "20px",
                marginTop: "5px",
                fontFamily: "Montserrat",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                textAlign: "left",
              }}
            >
              Safe and Reliable Transportation
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
